<template>
  <div class="bg-white">
     <Header  :leftHandler="back"></Header>
     <ReturnToLogin ref="ReturnToLogin" @after-confirm="handleJumpHome"></ReturnToLogin>
  </div>
</template>

<script>
import Header from '@/components/header.vue'
import { kangzhongApi } from '@/api/bind'
import { userUtils } from '@/utils/auth'
import ReturnToLogin from '@/views/activity/components/return-to-login.vue'
export default {
  components: {
    Header,
    ReturnToLogin
  },
  data () {
    return {
      ut: '',
      loginType: 'WX',
      token: '',
      targetUrl: '/v2/home-main'
    }
  },

  created () {
    this.token = this.$route.query.oauthToken || ''
    this.targetUrl = this.$route.query.target || '/v2/home-main'
    // const fromApp =  this.$route.query.appCode || ''
    this.externalLogin()
  },
  methods: {
    externalLogin () {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      kangzhongApi.externalLogin({ token: this.token }).then(res => {
        this.$toast.clear()
        if (res.data.resultCode === '0') {
          const { clientToken } = res.data.resultData
          this.ut = clientToken.token || ''
          this.entryValidate()
        } else {
          this.$dialog.alert({ message: res.data.resultMsg }).then(() => { })
        }
      }).catch(() => {
        this.$toast.clear()
        let that = this
        var home = setInterval(function () {
          that.$router.replace({ name: 'home-main' })
          clearInterval(home)
        }, 1500)
      })
    },
    entryValidate () {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        message: '登录中'
      })
      let params = {
        ut: this.ut,
        loginType: this.loginType
      }
      kangzhongApi.entryValidate(params).then(res => {
        this.$toast.clear()
        if (res.data.resultCode === '0') {
          userUtils.setUserLocal(res.data.resultData)
          if (res.data.resultData.activityCoinDTO) {
            // 回归活动
            this.$refs['ReturnToLogin'] && this.$refs['ReturnToLogin'].open(res)
          } else {
            this.handleJumpHome(res)
          }
        }
      }).catch(() => { this.$toast.clear() })
    },
    handleJumpHome (res) {
      if (res.data.resultData.clientInfo.isActivated === 0) {
        this.$router.replace({ name: 'activation_step_one' })
        return
      }
      window.location.replace(this.targetUrl)
      // this.$router.replace({ name: 'home-main' })
    },
    back () {
      this.$router.go(-1)
    }
  }
}
</script>
<style  scoped lang="less">
.bg-white {
  background-color: #fff !important;
  height: 100%;
}
</style>
